import useService from './axios-config';
import { COMMON } from '../constants';
const { _post, isApiSuccess } = useService();

const aehLoginAsync = (payload) => {
  return _post(COMMON.AEH_LOGIN, payload)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

export { aehLoginAsync };
